// import { Navigate } from "react-router-dom";
// import useAuthStore from "../store/authStore";

// export default function AuthGuard({
//     children,
// }) {
//     const user = useAuthStore(
//         (state) => state.user
//     );

//     if (!user) {
//         return <Navigate to="/login" />;
//     }

//     return children;
// }


import { Navigate } from "react-router-dom";
import { useAuthStore } from "../store/authStore";

export default function AuthGuard({ children }) {
  const { user } = useAuthStore();

  if (!user) {
    return <Navigate to="/" replace />;  // redirect to root (login page)
  }

  return children;
}